import React from "react";

/*
    Gear Icon
    props:
        - title: string, override the default title 'Gear'
        - color: string, override the default color '#00549A' (bell blue)
*/

const GearIcon = (props) => (
    <svg className={props.className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{props.title || "Technicians"}</title>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.6456 12C14.6456 13.4569 13.4585 14.644 12 14.644C10.5434 14.644 9.35496 13.4569 9.35496 12C9.35496 10.5428 10.5434 9.35753 12 9.35753C13.4595 9.35801 14.6456 10.5428 14.6456 12Z"
            stroke={props.color || "#00549A"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.9826 10.108L17.5658 9.09733C17.5658 9.09733 18.5354 6.86432 18.4497 6.77823L17.1663 5.49883C17.0778 5.41084 14.89 6.43008 14.89 6.43008L13.8809 6.01392C13.8809 6.01392 12.99 3.75 12.868 3.75H11.057C10.9308 3.75 10.1065 6.01868 10.1065 6.01868L9.09881 6.43674C9.09881 6.43674 6.86587 5.46697 6.77972 5.55353L5.4991 6.83483C5.41062 6.92282 6.42999 9.11065 6.42999 9.11065L6.01367 10.1204C6.01367 10.1204 3.75 11.0107 3.75 11.1311V12.9431C3.75 13.0701 6.0188 13.8948 6.0188 13.8948L6.43512 14.9031C6.43512 14.9031 5.46603 17.1347 5.55125 17.2208L6.83374 18.5031C6.92082 18.5896 9.10859 17.5704 9.10859 17.5704L10.1182 17.988C10.1182 17.988 11.0095 20.25 11.1329 20.25H12.9435C13.0687 20.25 13.8944 17.9813 13.8944 17.9813L14.9049 17.5637C14.9049 17.5637 17.1332 18.5335 17.2194 18.4484L18.5023 17.1671C18.5917 17.0777 17.5695 14.8913 17.5695 14.8913L17.9854 13.882C17.9854 13.882 20.25 12.9898 20.25 12.8675V11.0569C20.2509 10.9313 17.9826 10.108 17.9826 10.108Z"
            stroke={props.color || "#00549A"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default GearIcon;
